/* istanbul ignore file */
export var ApiServiceEvent;
(function (ApiServiceEvent) {
    ApiServiceEvent["MetaReceived"] = "MetaReceived";
    ApiServiceEvent["SessionRefreshed"] = "SessionRefreshed";
})(ApiServiceEvent || (ApiServiceEvent = {}));
